module.exports = __webpack_public_path__ + "static/media/photo184.76802fcc.jpg";